import React, { createContext, useContext, useState, useCallback } from 'react';

export const FloatingChatContext = createContext();

export const FloatingChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [targetSellerId, setTargetSellerId] = useState(null);
  const [hideForSellerOwnProduct, setHideForSellerOwnProduct] = useState(false);

  const openFloatingChat = useCallback((sellerUserId) => {
    setTargetSellerId(sellerUserId);
    setIsOpen(true);
  }, []);

  const closeFloatingChat = useCallback(() => {
    setIsOpen(false);
    setTargetSellerId(null);
  }, []);

  const value = {
    isOpen,
    targetSellerId,
    openFloatingChat,
    closeFloatingChat,
    hideForSellerOwnProduct,
    setHideForSellerOwnProduct,
  };

  return (
    <FloatingChatContext.Provider value={value}>
      {children}
    </FloatingChatContext.Provider>
  );
};

export const useFloatingChat = () => {
  const context = useContext(FloatingChatContext);
  if (!context) {
    throw new Error('useFloatingChat must be used within FloatingChatProvider');
  }
  return context;
};
